import { render, staticRenderFns } from "./ShipmentStatusProgress.vue?vue&type=template&id=5c99dff0&scoped=true"
import script from "./ShipmentStatusProgress.vue?vue&type=script&lang=js"
export * from "./ShipmentStatusProgress.vue?vue&type=script&lang=js"
import style0 from "./ShipmentStatusProgress.vue?vue&type=style&index=0&id=5c99dff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99dff0",
  null
  
)

export default component.exports